const PLATFORM_APP_HOST = (process.env.REACT_APP_PLATFORM_APP_HOST || "buildhof.com")
  .trim()
  .toLowerCase()
  .replace(/^https?:\/\//, "")
  .replace(/\/$/, "");

export function normalizeHostname(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .replace(/:\d+$/, "")
    .replace(/\.$/, "");
}

/** True when the browser is on a merchant custom domain (not BuildHof / localhost). */
export function isCustomDomainHost(hostname = typeof window !== "undefined" ? window.location.hostname : "") {
  const host = normalizeHostname(hostname);
  if (!host) return false;
  if (host === "localhost" || host === "127.0.0.1" || host.endsWith(".localhost")) return false;

  const appHost = normalizeHostname(PLATFORM_APP_HOST);
  const appBare = appHost.replace(/^www\./, "");
  if (host === appHost || host === appBare || host === `www.${appBare}`) return false;
  return true;
}

/** Path prefix for storefront links: "" on custom domain, "/{slug}" on platform. */
export function storeBasePath(slug, { customDomain = isCustomDomainHost() } = {}) {
  if (customDomain) return "";
  const clean = String(slug || "").replace(/^\/+|\/+$/g, "");
  return clean ? `/${clean}` : "";
}

/** Build a storefront path, e.g. storePath(slug, "/menu") → "/menu" or "/sitara/menu". */
export function storePath(slug, suffix = "", opts) {
  const base = storeBasePath(slug, opts);
  const raw = String(suffix || "");
  const path = !raw ? "" : raw.startsWith("/") ? raw : `/${raw}`;
  return `${base}${path}` || "/";
}
